import { createLogic } from 'redux-logic';

import { SBA_AUTH_METHOD, SSO_AUTH_METHOD } from 'config/constants';
import { getGatekeeperTokenForBooking } from 'lib/authenticationApi';
import { qffAuthInit } from 'lib/qffAuth';

import * as authenticationActions from '../actions';
import * as sbaActions from '../sba/actions';
import { getBookingAuthMethod } from 'lib/graphql';

const retrieveBookingAuthenticationMethod = createLogic({
  type: authenticationActions.retrieveBookingAuthMethod,
  async process({ action, client }, dispatch, done) {
    const { bookingId } = action.payload;

    const result = await getBookingAuthMethod(client, { variables: { bookingId }, fetchPolicy: 'cache-first' });
    const { authMethod } = result.data;

    dispatch(authenticationActions.updateAuthMethod({ authMethod }));

    if (authMethod === SBA_AUTH_METHOD) {
      const token = getGatekeeperTokenForBooking(bookingId);
      dispatch(sbaActions.updateSBAAuthentication({ token }));
      // TODO: Should this action be triggered for both types?
      dispatch(authenticationActions.updateFetchBookingAuthProcess({ done: true }));
    } else if (authMethod === SSO_AUTH_METHOD) {
      qffAuthInit();
    }

    // TODO: Catch "unknown" auth types (would usually indicate 404)

    done();
  },
});

export default retrieveBookingAuthenticationMethod;
